
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountAuthorizationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorizationResponse"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAuthorize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expirationDatetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"otpPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relatedData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationTotalPrice"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oldPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentCardMaskedPan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderAmount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderBankAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iban"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderConstantSymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderNote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderSpecificSymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderVariableSymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderTemplateNextPaymentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderTemplateFrequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderTemplateValidTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentOrderFee"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"investmentsOldValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investmentsNewValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transactionValue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"validThru"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":813}};
    doc.loc.source = {"body":"#import \"fragments/AmountFragment.graphql\"\n\nfragment AccountAuthorizationFragment on AuthorizationResponse {\n\tcanAuthorize\n\texpirationDatetime\n\tid\n\totpPhone\n\trelatedData {\n\t\tapplicationTotalPrice {\n\t\t\t...AmountFragment\n\t\t}\n\t\tmerchantName\n\t\tnewEmail\n\t\toldEmail\n\t\tnewPhone\n\t\toldPhone\n\t\tpaymentCardMaskedPan\n\t\tpaymentOrderAmount {\n\t\t\t...AmountFragment\n\t\t}\n\t\tpaymentOrderBankAccount {\n\t\t\tiban\n\t\t}\n\t\tpaymentOrderConstantSymbol\n\t\tpaymentOrderMessage\n\t\tpaymentOrderNote\n\t\tpaymentOrderSpecificSymbol\n\t\tpaymentOrderVariableSymbol\n\t\tpaymentOrderTemplateNextPaymentDate\n\t\tpaymentOrderTemplateFrequency\n\t\tpaymentOrderTemplateValidTo\n\t\tpaymentOrderFee {\n\t\t\t...AmountFragment\n\t\t}\n\t\tinvestmentsOldValue\n\t\tinvestmentsNewValue\n\t\ttransactionValue {\n\t\t\t...AmountFragment\n\t\t}\n\t\tvalidThru\n\t\tredirectUrl\n\t}\n\tslug\n\tstate\n\ttitle\n\ttype\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("fragments/AmountFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AccountAuthorizationFragment"] = oneQuery(doc, "AccountAuthorizationFragment");
        
